import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7df882b1")

_pushScopeId("data-v-7df882b1")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("lorem ipsum")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ExampleBox = _resolveComponent("ExampleBox")

  return (_openBlock(), _createBlock(_component_ExampleBox, { class: "demo" }, {
    default: _withId(() => [
      _hoisted_1
    ]),
    _: 1
  }))
})